import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".iframe {\n  height: 100vh;\n  height: 100dvh;\n  width: 100%;\n  border: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}";
styleInject(css_248z$1);

var EFEEvent;
(function (EFEEvent) {
    EFEEvent["ORDER_CREATED"] = "appcharge_order_created";
    EFEEvent["PAYMENT_INTENT_SUCCESS"] = "appcharge_payment_intent_success";
    EFEEvent["PAYMENT_INTENT_FAILED"] = "appcharge_payment_intent_failed";
    EFEEvent["ORDER_COMPLETED_SUCCESS"] = "appcharge_order_completed_success";
    EFEEvent["ORDER_COMPLETED_FAILED"] = "appcharge_order_completed_failed";
    EFEEvent["CLOSE_CHECKOUT"] = "appcharge_close_checkout";
    EFEEvent["CHECKOUT_OPENED"] = "appcharge_checkout_opened";
    EFEEvent["APPCHARGE_THEME"] = "appcharge_theme";
})(EFEEvent || (EFEEvent = {}));
function AppchargeCheckout(_a) {
    var checkoutUrl = _a.checkoutUrl, playerId = _a.playerId, sessionToken = _a.sessionToken, sourceVersion = _a.sourceVersion, checkoutToken = _a.checkoutToken, locale = _a.locale, mode = _a.mode, checkoutStyle = _a.checkoutStyle, customization = _a.customization, onClose = _a.onClose, onOpen = _a.onOpen, onInitialLoad = _a.onInitialLoad, onOrderCreated = _a.onOrderCreated, onPaymentIntentFailed = _a.onPaymentIntentFailed, onPaymentIntentSuccess = _a.onPaymentIntentSuccess, onOrderCompletedFailed = _a.onOrderCompletedFailed, onOrderCompletedSuccessfully = _a.onOrderCompletedSuccessfully;
    useEffect(function () {
        var eventHandler = function (massageEvent) {
            if (massageEvent.origin !== checkoutUrl)
                return;
            var _a = massageEvent.data, params = _a.params, event = _a.event;
            switch (event) {
                case EFEEvent.ORDER_CREATED:
                    onOrderCreated === null || onOrderCreated === void 0 ? void 0 : onOrderCreated(params);
                    break;
                case EFEEvent.ORDER_COMPLETED_FAILED:
                    onOrderCompletedFailed === null || onOrderCompletedFailed === void 0 ? void 0 : onOrderCompletedFailed(params);
                    break;
                case EFEEvent.ORDER_COMPLETED_SUCCESS:
                    onOrderCompletedSuccessfully === null || onOrderCompletedSuccessfully === void 0 ? void 0 : onOrderCompletedSuccessfully(params);
                    break;
                case EFEEvent.PAYMENT_INTENT_FAILED:
                    onPaymentIntentFailed === null || onPaymentIntentFailed === void 0 ? void 0 : onPaymentIntentFailed(params);
                    break;
                case EFEEvent.PAYMENT_INTENT_SUCCESS:
                    onPaymentIntentSuccess === null || onPaymentIntentSuccess === void 0 ? void 0 : onPaymentIntentSuccess(params);
                    break;
                case EFEEvent.CLOSE_CHECKOUT:
                    onClose === null || onClose === void 0 ? void 0 : onClose(params);
                    break;
                case EFEEvent.CHECKOUT_OPENED:
                    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
                    break;
            }
        };
        window.addEventListener('message', eventHandler);
        return function () {
            window.removeEventListener('message', eventHandler);
        };
    }, [
        checkoutUrl,
        onOrderCreated,
        onPaymentIntentFailed,
        onPaymentIntentSuccess,
        onOrderCompletedFailed,
        onOrderCompletedSuccessfully,
    ]);
    if (!checkoutToken) {
        throw Error('checkoutToken prop is missing in AppchargeCheckout component');
    }
    var sdkVersion = '3.3.0';
    var queryParams = "sdk-version=react-".concat(sdkVersion, "&source-version=").concat(sourceVersion || '', "&checkout-token=").concat(checkoutToken).concat(locale ? "&locale=".concat(locale) : '').concat(playerId ? "&player_id=".concat(playerId) : '').concat(mode ? "&mode=".concat(mode) : '');
    var checkoutStyleParams = checkoutStyle ? "&overlay-background-color=".concat(checkoutStyle.overlayBackgroundColor || '') : '';
    // new customization params, align other query param logic to be the same using URLSearchParams
    var customizationSearchParams = '';
    try {
        customizationSearchParams = customization ? new URLSearchParams({ customization: JSON.stringify(customization) }).toString() : '';
    }
    catch (_b) {
    }
    var url = "".concat(checkoutUrl, "/").concat(sessionToken, "?").concat(queryParams).concat(checkoutStyleParams, "&").concat(customizationSearchParams);
    return (jsx("iframe", { src: url, className: "iframe", title: "checkout", allow: "payment *", onLoad: function () { return onInitialLoad === null || onInitialLoad === void 0 ? void 0 : onInitialLoad(); } }));
}

var css_248z = ".iframe-transparent {\n  width: 0px;\n  height: 0px;\n  visibility: hidden;\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n}";
styleInject(css_248z);

function AppchargeCheckoutInit(_a) {
    var _b = _a.environment, environment = _b === void 0 ? 'sandbox' : _b; _a.domain; var checkoutToken = _a.checkoutToken;
    var env = environment === 'prod' ? '' : "-".concat(environment);
    if (!checkoutToken) {
        throw Error('checkoutToken prop is missing in AppchargeCheckoutInit component');
    }
    return (jsx("iframe", { src: "https://checkout-v2".concat(env, ".appcharge.com/handshake?checkout-token=").concat(checkoutToken), className: "iframe-transparent", title: "checkout-transparent" }));
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getPricePoints(environment, domain) {
    if (environment === void 0) { environment = "sandbox"; }
    if (domain === void 0) { domain = window.location.host; }
    return __awaiter(this, void 0, void 0, function () {
        var env, apiUrl, pricePointsResponse, pricePoints;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    env = environment === "prod" ? "" : "-".concat(environment);
                    apiUrl = "https://api".concat(env, ".appcharge.com/checkout/v1/").concat(domain, "/pricingPoints");
                    return [4 /*yield*/, fetch(apiUrl)];
                case 1:
                    pricePointsResponse = _a.sent();
                    return [4 /*yield*/, pricePointsResponse.json()];
                case 2:
                    pricePoints = _a.sent();
                    if (!pricePointsResponse.ok) {
                        throw pricePoints === null || pricePoints === void 0 ? void 0 : pricePoints.message;
                    }
                    return [2 /*return*/, pricePoints];
            }
        });
    });
}

export { AppchargeCheckout, AppchargeCheckoutInit, getPricePoints };
//# sourceMappingURL=index.esm.js.map
